import { render, staticRenderFns } from "./CheckoutThankYou.vue?vue&type=template&id=0702c9ba"
import script from "./CheckoutThankYou.vue?vue&type=script&lang=ts"
export * from "./CheckoutThankYou.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports